import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { UserTypeTabEnum } from 'projects/admin/src/app/features/user-management/internal-users/models/enums/userTypeTabEnum';
import { RoleType } from 'projects/admin/src/app/features/user-management/roles/models/enums/roleType';
import { SystemModule } from 'projects/admin/src/app/features/central-hub/models/enums/SystemModule';
import FileSaver from 'file-saver';

@Injectable({ providedIn: 'root' })

export class LookupsService {
  refreshList = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) {
  }

  getMenuBasedOnPermissions(centralhubCode: SystemModule): any {
    return this.http.get(`${environment.apiUrl}/menu/GetMenuBasedOnPermissions?centralhubCode=${centralhubCode}`);
  }

  getSupportingDocumentTypes() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetSupportingDocumentTypes`);
  }

  getLawLegislationRegulationTypes() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetLawLegislationRegulationTypes`);
  }

  getInstitution() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetInstitutionLookup`);
  }
  getLanguages() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetLanguages`);
  }
  getCategoryTypes() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCategoryTypes`);
  }
  getLawLegislationRegulations() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetLawLegislationRegulations`);
  }

  getCities() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCities`);
  }

  // new lookups
  getAllDepartment() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllDepartment`);
  }
  getAllEntities() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllEntities`);
  }
  getRolesByRoleType(roleType: RoleType) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetRolesByRoleType?roleType=${roleType}`);
  }
  getAllCountries() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllCountries`);
  }
  getCitiesByCountryId(countryId: any) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCitiesByCountryId?countryId=${countryId}`);
  }
  getOperatorTypes() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetOperatorTypes`);
  }
  getSaudiCities() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetSaudiCities`);
  }

  getCommercialSectors(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCommercialSectors`);
  }
  getRelatedStarRatingAnswers(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetRelatedStarRatingAnswers`);
  }
  getQuestionTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetQuestionTypes`);
  }
  getCheckFormQuestionTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCheckFormQuestionTypes`);
  }
  getViolations(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetViolations`);
  }
  getEconomicOperatorLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEconomicOperatorLookup`);
  }
  getEconomicOperatorBranchesLookup(economicOperatorId: number): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEconomicOperatorBranchesLookup?economicOperatorId=${economicOperatorId}`);
  }
  getEvaluationRequestBranchesLookup(evaluationRequestId: number): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEvaluationRequestBranchesLookup?evaluationRequestId=${evaluationRequestId}`);
  }
  getEvaluationSurveyTemplatesLookup(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEvaluationSurveyTemplatesLookup`, { params });
  }
  getTaskPriorityLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetTaskPriorityLookup`);
  }
  getTaskStatusLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetTaskStatusLookup`);
  }
  getTaskStatusLookupByTab(tab: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetTaskStatusLookupByTab?tab=${tab}`);
  }
  getBasketTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetBasketTypes`);
  }
  getProductsLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetProductsLookup`);
  }

  getSubProductCategoriesByMainCategoryId(mainCategoryId: any) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetSubProductCategoriesByMainCategoryId?mainCategoryId=${mainCategoryId}`);
  }
  getSubCategoriesByMainCategory(mainCategoryId: any) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetSubCategoriesByMainCategory?mainCategoryId=${mainCategoryId}`);
  }
  getMainProductCategories(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetMainProductCategories`);
  }
  getBrandsLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetBrandsLookup`);
  }
  getCountries(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/Countries`);
  }
  getEconomicOperatorByType(storeType: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEconomicOperatorByType?storeType=${storeType}`);
  }
  getBasketsLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetBasketsLookup`);
  }
  GetEconomicOperatorByCityIdAndType(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEconomicOperatorByCityIdAndType`, { params });
  }

  MedicalTreatmentPhases(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/MedicalTreatmentPhases`);
  }

  getMonitorTaskStatusLookupByTab(tab: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetMonitorTaskStatusLookupByTab?tab=${tab}`);
  }

  getMonitorTaskStatusLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/getMonitorTaskStatusLookup`);
  }

  getRelatedTracksLkp(hubCode: SystemModule): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetRelatedTracksLkp?hubCode=${hubCode}`);
  }

  getRelatedGroupsLkp(hubCode: SystemModule): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetRelatedGroupsLkp?hubCode=${hubCode}`);
  }

  getAllMainCategories(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllMainCategories`, { params });
  }

  getAllSubCategories(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllSubCategories`, { params });
  }

  getListCountries(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetListCountries`, { params });
  }

  getAllBrands(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllBrands`, { params });
  }

  getAllSaudiCities(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllSaudiCities`, { params });
  }

  getPublicGetInstitutionLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/PublicGetInstitutionLookup`);
  }

  getCheckFormLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCheckFormLookup`);
  }

  getCheckTypes(categoryType: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCheckTypes?categoryType=${categoryType}`);
  }

  getVerificationRequestBranchesLookup(verificationRequestId: number): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetVerificationRequestBranchesLookup?verificationRequestId=${verificationRequestId}`);
  }

  getVerificationTaskStatusLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetVerificationTaskStatusLookup`);
  }

  getVerificationTaskStatusLookupByTab(tab: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetVerificationTaskStatusLookupByTab?tab=${tab}`);
  }

  getProductsBySubCategoryId(subProductCategoryId: number) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetProductsBySubCategoryId?subProductCategoryId=${subProductCategoryId}`);
  }

  getProductEvaluationTaskStatusLookup() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetProductEvaluationTaskStatusLookup`);
  }

  getAllCriteriaType(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllCriteriaType`);
  }

  getAllTechnicalCriteriaAnswerType(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllTechnicalCriteriaAnswerType`);
  }
  getProductEvaluationTaskStatusLookupByTab(tab: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetProductEvaluationTaskStatusLookupByTab?tab=${tab}`);
  }

  getComparisonProductsLookup(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetComparisonProductsLookup`, { params });
  }
  getAllFraudDetectionQuestionTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllFraudDetectionQuestionTypes`);
  }
  getAllFraudCheckForms(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllFraudCheckForms`);
  }
  getAllPubllishedFraudCheckForms(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllPubllishedFraudCheckForms`);
  }
  getAllInstitutionLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllInstitutionLookup`);
  }

  getAllComplainceStatus(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllComplainceStatus`);
  }

  getAllFraudTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllFraudTypes`);
  }

  getMonitoringTargetChannels(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetMonitoringTargetChannels`);
  }

  getFraudTaskStatusLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetFraudTaskStatusLookup`);
  }

  getFraudTaskStatusLookupByTab(tab: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetFraudTaskStatusLookupByTab?tab=${tab}`);
  }

  getAllReusePaths(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllReusePaths`);
  }

  getDocumentCategoryLookups(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/DocumentCategoryLookups`);
  }

  getDocumentCategoryLookupsForAdding(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/DocumentCategoryLookupsForAdding`);
  }

  getNationalities() {
    return this.http.get(`${environment.apiUrl}/Lookup/Nationalities`);
  }
  GetCountries() {
    return this.http.get(`${environment.apiUrl}/lookup/Countries`);
  }
  GetCities(countryId) {
    return this.http.get(`${environment.apiUrl}/lookup/Cities/${countryId}`);
  }
  getMenu() {
    return this.http.get(`${environment.apiUrl}/lookup/GetMenu`);
  }

  GetCurrentYear() {
    return this.http.get(`${environment.apiUrl}/lookup/GetCurrentYear`);
  }

  GetBillingType(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetBillingType`);
  }

  getEducationalDegrees(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEducationalDegrees`);
  }
  getAllEmploymentTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllEmploymentTypes`);
  }
  getConsumers(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetConsumers`);
  }
  getFraudTypes(params: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetFraudTypes`, { params });
  }

  getCertificateRequestStatus(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCertificateRequestStatus`);
  }

  getLookupOfferTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetLookupOfferTypes`);
  }

  getAllOfferTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllOfferTypes`);
  }

  getEconomicOperatorBranches(params?: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEconomicOperatorBranches`, { params });
  }
  getAllOperatorsHasOffers(params?: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllOperatorsHasOffers`, { params });
  }

  getQuoteScopeData(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetQuoteScopeData`);
  }
  getAllSurveyAndOpinionPollQuestionTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllSurveyAndOpinionPollQuestionTypes`);
  }

  getAllSurveyAndOpinionPollPurposes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllSurveyAndOpinionPollPurposes`);
  }

  getAllSuveryGeographicScopes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllSuveryGeographicScopes`);
  }

  getAllPublishedSurveyAndOpinionsTemplates(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllPublishedSurveyAndOpinionsTemplates`);
  }

  getBankData(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetBankData`);
  }

  getSurveyTaskStatusLookupByTab(tab: any): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetSurveyTaskStatusLookupByTab?tab=${tab}`);
  }

  getSurveyTaskStatusLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetSurveyTaskStatusLookup`);
  }

  getConsultationTypesLookup(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetConsultationTypesLookup`);
  }

  getAllConsultationMeetingDuration() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllConsultationMeetingDuration`);
  }

  getPaymentMethodsLookup() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetPaymentMethodsLookup`);
  }



  // For Courses
  getAllLabsAndVirualLABslookups(params: any = null) {
    return this.http.get(`${environment.apiUrl}/Lookups/GetAllLabsAndVirualLABslookups`, { params });
  }

  getEntityCourseCategories() {
    return this.http.get(`${environment.apiUrl}/Lookups/GetEntityCourseCategories`);
  }

  getSlides(params) {
    return this.http.get(`${environment.apiUrl}/Lookups/FilterSlides`, { params });
  }

  getQuestionBankCategories() {
    return this.http.get(`${environment.apiUrl}/Lookups/GetQuestionBankCategories`);
  }

  getQuestionBankDifficulties() {
    return this.http.get(`${environment.apiUrl}/Lookups/GetQuestionBankDifficulties`);
  }

  getQuestionBanks() {
    return this.http.get(`${environment.apiUrl}/Lookups/ListMyQuestionBanks`);
  }

  getAllContentTypes() {
    return this.http.get(`${environment.apiUrl}/Lookups/GetAllContentTypes`);
  }

  getAllQuizQuestionType() {
    return this.http.get(`${environment.apiUrl}/Lookups/GetAllQuizQuestionType`);
  }

  getListMyTags() {
    return this.http.get(`${environment.apiUrl}/Lookups/ListMyTags`);
  }

  getAllCourseOutComes(params) {
    return this.http.get(`${environment.apiUrl}/Lookups/GetAllCourseOutComes`, { params });
  }

  anonymousCourseCategories(params) {
    return this.http.get(`${environment.apiUrl}/Lookups/AnonymousCourseCategories`, { params });
  }

  getAllLanguages() {
    return this.http.get(`${environment.apiUrl}/Lookups/GetAllLanguages`);
  }


  downloadAttachment(file) {
    return this.http.get(
      `${environment.apiUrl}/Lookup/DownloadAttachment/${file.attachmentId}?Url=${file.path}`
    ).pipe().subscribe((response: any) => {
      const blob = this.dataURItoBlob(response.file); // base 64 to blob
      const blobFile: Blob = new Blob([blob], { type: response.contentType });
      FileSaver.saveAs(blobFile, response.name);
    });
  }
  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }
}
